import React, { FC, useState, useEffect } from 'react';
import { Category, HeaderData } from '../models';
import LanguageSelectionScreen from '../LanguageSelectionScreen';
import MainScreen from './MainScreen';

const ScreenMapTypes = {
  main: {},
  language: {},
};

export type MobileHeaderScreenMapTypes = keyof typeof ScreenMapTypes;
export type SetActiveMobileScreenCb = React.Dispatch<
  React.SetStateAction<MobileHeaderScreenMapTypes>
>;
interface Props {
  isUserLoggedIn: boolean;
  sortedCategories: Array<Category>;
  marketplaceUrlPrefix: string;
  headerData?: HeaderData;
  language: string;
  pageName?: string;
  isLess1000View: boolean;
}

const MobileScreens: FC<Props> = ({
  isUserLoggedIn,
  sortedCategories,
  marketplaceUrlPrefix,
  headerData = {
    keys: {},
    services: [],
    userData: {},
    userProfileImage: '',
  },
  language = 'en',
  pageName = 'explore',
  isLess1000View,
}) => {
  const [activeScreen, setActiveScreen] =
    useState<MobileHeaderScreenMapTypes>('main');

  useEffect(() => {
    if (!isLess1000View) {
      setActiveScreen('main');
    }
  }, [isLess1000View]);

  const onMobileMenuBack = () => {
    setActiveScreen('main');
  };

  const ScreenMap = (data: HeaderData) => ({
    main: (
      <MainScreen
        isUserLoggedIn={isUserLoggedIn}
        language={language}
        marketplaceUrlPrefix={marketplaceUrlPrefix}
        sortedCategories={sortedCategories}
        keys={headerData.keys}
        pageName={pageName}
        setActiveScreen={setActiveScreen}
      />
    ),
    language: (
      <LanguageSelectionScreen
        title={data?.keys?.mobileLanguageSelectionTitle}
        onBack={onMobileMenuBack}
        value={language}
        pageName={pageName}
      />
    ),
  });

  return ScreenMap(headerData)[activeScreen];
};

export default MobileScreens;
